import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header';
import Footer from './components/Footer';

// Pages
import HomePage from './pages/HomePage';
import PrivatePage from './pages/PrivatePage';
import ErhvervPage from './pages/ErhvervPage';
import ArticlesPage from './pages/ArticlesPage';
import ArticleDetailPage from './pages/ArticleDetailPage';
import PresseFilmPage from './pages/PresseFilmPage';
import PresseFilmDetailPage from './pages/PresseFilmDetailPage';
import OmSkatPage from './pages/OmSkatPage';
import OmSkatDetailPage from './pages/OmSkatDetailPage';
import HelpPage from './pages/HelpPage';
import ContactPage from './pages/ContactPage';
import NotFoundPage from './pages/NotFoundPage';
import ForbiddenPage from './pages/ForbiddenPage';

export default function App() {
  return (
    <div className="flex min-h-screen flex-col bg-white text-[#010b27] antialiased selection:bg-[#fd7302] selection:text-white">
      <ScrollToTop />
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/private" element={<PrivatePage />} />
          <Route path="/erhvervsdrivende" element={<ErhvervPage />} />
          <Route path="/artikler" element={<ArticlesPage />} />
          <Route path="/artikler/:slug" element={<ArticleDetailPage />} />
          <Route path="/presse-og-film" element={<PresseFilmPage />} />
          <Route path="/presse-og-film/:slug" element={<PresseFilmDetailPage />} />
          <Route path="/om-skat" element={<OmSkatPage />} />
          <Route path="/om-skat/:slug" element={<OmSkatDetailPage />} />
          <Route path="/har-brug-for-hjaelp" element={<Navigate to="/kontakt" replace />} />
          <Route path="/skatteborger" element={<Navigate to="/kontakt" replace />} />
          <Route path="/kontakt" element={<ContactPage />} />
          <Route path="/403" element={<ForbiddenPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}
